import { gql } from "@apollo/client";

export const DELETE_ADMIN = gql`
  mutation removeAdmin($id: Int!) {
    removeAdmin(id: $id) {
      id
    }
  }
`;
